import styled from 'styled-components';
import { Link } from 'gatsby';
export const Wrapper = styled.article`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--light-gray-2);
  border-radius: 4px;
  transition: var(--mainTransition);
  cursor: pointer;
  margin-bottom: 2rem;
  color: inherit;
  &:hover {
    transform: translateY(-3px);
  }
`;

export const LinkImageContainer = styled(Link)`
  transition: var(--mainTransition);
  position: relative;
  background-color: var(--primaryColor);
  height: 160px;
  width: 100%;
  overflow: hidden;
  &:hover {
    img {
      transform: scale(1.2);
    }
  }
  img {
    height: 100%;
    width: 100%;
    transition: transform 6s;
    object-fit: cover;
  }
`;

export const PostContent = styled.div`
  padding: 0 1rem;
  text-align: left;
  & > *:not(:last-child) {
    margin-bottom: 0.75rem;
  }
`;

export const PostTitle = styled.h3`
  padding: 0;
  font-size: 1.1rem;
  font-weight: 600;
`;

export const PostDetails = styled.div`
  & > *:not(last-child) {
    margin-bottom: 0.5rem;
  }
`;

export const PostDetailItem = styled.div`
  display: flex;
  align-items: center;
  font-size: 0.85rem;
  svg {
    font-size: 1.2rem;
  }
  & > *:not(:first-child) {
    margin-left: 0.5rem;
  }
`;
